import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle } from '@fortawesome/pro-regular-svg-icons';

export const Plays = ({ plays, extraMargin }) => {
  const { t } = useTranslation();

  const extraMarginClass = extraMargin ? ' ct-video-metadata__li' : '';
  return (
    <span
      data-e2e="video-plays"
      className={`ct-video-metadata__li ct-video-metadata__icon ct-video-metadata__icon--plays${extraMarginClass}`}
    >
      <FontAwesomeIcon className="video-metadata-icon" icon={faPlayCircle} />
      {plays} {t('plays')}
    </span>
  );
};
